<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="#6DAADD" stroke="#6DAADD" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.494 5.275a7.77 7.77 0 0 1 0 10.989l-4.2 4.2a1.83 1.83 0 0 1-2.589 0l-4.2-4.2h0a7.77 7.77 0 0 1 0-10.989h0a7.77 7.77 0 0 1 10.99 0h0Z" />
    <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12.002 13.438a2.666 2.666 0 1 0 0-5.332 2.666 2.666 0 0 0 0 5.332Z" />
  </svg>
</template>
